.ae{overflow:hidden;}